export default __webpack_public_path__ + "media/music/8d6b060ce96aa678af2179d9ebe6748c.mp3";